
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import main_img from "../assets/register/main.webp";
import './register.css';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import img1 from '../assets/c1.png'
import img2 from '../assets/c2.png'
import img3 from '../assets/c3.png'
import img4 from '../assets/c4.png'
import img5 from '../assets/c5.png'
import img6 from '../assets/c6.png'
import img7 from '../assets/c7.png'
import img8 from '../assets/logo/bits.png'
import img9 from '../assets/logo/iit_b.png'

import S1 from '../assets/SVG/SINGLE BUTTON-01.svg'
import S2 from '../assets/SVG/double button-01.svg'
import S3 from '../assets/SVG/three button-01.svg'

import b1 from '../assets/SVG/SIDE VENT.svg'
import b2 from '../assets/SVG/SINGLE VENT.svg'
import b3 from '../assets/SVG/NON VENT.svg'

import c1 from '../assets/SVG/SEMI SPREAD.svg'
import c2 from '../assets/SVG/MANDARIN.svg'
import c3 from '../assets/SVG/SPREAD_n.svg'

import iphone from '../assets/register/iphone.png'

import raymond from '../assets/icon/Raymond.svg'

import Register_form from "./register_form";



function Register() {
    const navigate = useNavigate();

    const dj = useMemo(() => "https://firebasestorage.googleapis.com/v0/b/maviinvi.appspot.com/o/Brands%2FD%26J-01.svg-1726043197898?alt=media&token=01e4d492-9bc4-421c-b2d7-7dc408e06786", [])
    const siya = useMemo(()=> "https://firebasestorage.googleapis.com/v0/b/maviinvi.appspot.com/o/Brands%2Fsiyarams-01.svg-1725108936861?alt=media&token=9fd84714-7024-4196-996f-2e4ccefccff0", []) 

    const colabs = useMemo(() => [img1, img2, img3, img4, img5,img6, img7, img8, img9], [])
    const svgs = useMemo(() => [S1, S2, S3, b1, b2, b3, c1, c2, c3], [])
    const logos = useMemo(() => [raymond, dj, siya], [])

    const notify = () => toast.info("Registration Successful", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
        });

    return (
    <div className="register_container">
        <button className="register_back_btn" onClick={() => navigate('/')}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
        </button>

        <ToastContainer position="bottom-center" />

        <div className="register_left">
            <div className="register_left_content">
                <span className="txt-font">Dress to impress - It's Placement Season!</span>
                <h1 className="register_title">Suit Up<br/>Campus<br/>2026</h1>
                <p style={{fontSize: '1.1rem', maxWidth: '400px', opacity: 0.8}}>
                    India's top fabric brands at student-friendly prices. 
                    Get custom-tailored for your professional journey.
                </p>
            </div>
        </div>

        <div className="register_right">
            <div className="register_form_wrapper">
                <Register_form notify={notify} />
                <div className="register_footer_links">
                    Already have an account? 
                    <span className="register_link" onClick={() => navigate('/login')}>Login</span>
                </div>
            </div>
        </div>
    </div> );

}

export default Register;